import {
  ActAndSFStatus,
  ICommonDocument,
  PaymentDocumentKind,
  PaymentDocumentSubject,
  ServiceUpdDocumentServer,
  normalizeCommonDocument
} from 'shared/entities/documents';

import { ServiceDocumentCommonParamsTableModel } from './ServiceDocumentCommonParamsTableModel';
import { BaseDocumentModel } from './BaseDocumentModel';

export class ServiceUPDDocumentModel extends BaseDocumentModel {
  readonly status: ActAndSFStatus;
  readonly xmlUrl: string | null;
  readonly oneAssError: string | null;
  readonly kind: PaymentDocumentKind.upd = PaymentDocumentKind.upd;
  readonly subject: PaymentDocumentSubject.service =
    PaymentDocumentSubject.service;
  readonly params: ServiceDocumentCommonParamsTableModel;

  constructor({
    params,
    status,
    xmlUrl,
    oneAssError,
    ...rest
  }: ICommonDocument & {
    params: ServiceDocumentCommonParamsTableModel;
    status: ActAndSFStatus;
    xmlUrl: string | null;
    oneAssError: string | null;
    cabinetId: string;
  }) {
    super(rest);
    this.status = status;
    this.xmlUrl = xmlUrl;
    this.oneAssError = oneAssError;
    this.params = params;
  }

  static fromJson(
    raw: ServiceUpdDocumentServer,
    cabinetId: string
  ): ServiceUPDDocumentModel {
    const normalized = normalizeCommonDocument({
      ...raw,
      url: raw.url ?? ''
    });

    return new ServiceUPDDocumentModel({
      ...normalized,
      status: raw.status,
      xmlUrl: raw.xml_url ?? null,
      oneAssError: raw.one_ass_error ?? null,
      params: ServiceDocumentCommonParamsTableModel.fromJson(raw.params),
      cabinetId
    });
  }
}
